import { render } from "./PartnerDrivers.vue?vue&type=template&id=498e1d96&scoped=true"
import script from "./PartnerDrivers.vue?vue&type=script&lang=js"
export * from "./PartnerDrivers.vue?vue&type=script&lang=js"

import "./PartnerDrivers.vue?vue&type=style&index=0&id=498e1d96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498e1d96"]])

export default __exports__